import {
  IRootWidget,
  TreeNavigatorLogic,
  Widget,
  WidgetRepository,
  set,
} from '@framework/engine';
import { useCallback, useMemo, useState } from 'react';

export interface IWidgetConfigEditorProps {
  root: IRootWidget | undefined;
  updateRoot: (input: IRootWidget) => void;
}

/**
 * Hook per l'editor di gestione specializzato nel drawer di configurazione
 * dei widget lato configurazione modulo
 */
export function useWidgetConfigEditor(props: IWidgetConfigEditorProps) {
  const { root, updateRoot } = props;
  /** Elemento selezionato dall'azione di modifica */
  const [selected, setSelected] = useState<Widget | null>();

  const selectedWidgetType = useMemo(() => {
    if (!selected) return null;
    const type = WidgetRepository.find(selected.type);
    return type;
  }, [selected]);

  const openConfig = useCallback((widget: Widget) => {
    setSelected(widget);
  }, []);

  const closeConfig = useCallback(() => {
    setSelected(null);
  }, []);

  const apply = useCallback(
    (value: Widget) => {
      if (!root) return;
      if (!selected) return;

      const path = TreeNavigatorLogic.getNodePath(selected);

      // Imposto il nuovo widget modificato con la set di lodash per aggiornare
      // gli states
      const newWidgets = set(root, path, value as any);
      updateRoot(newWidgets);
    },
    [root, updateRoot, selected],
  );

  return {
    selected,
    openConfig,
    closeConfig,
    apply,
    selectedWidgetType,
  };
}

export type IWidgetConfigEditor = ReturnType<typeof useWidgetConfigEditor>;
